export const CompType = 'wysiwyg.viewer.components.ExpandableMenu';
export const PropertiesType = 'ExpandableMenuProperties';
export const DataType = 'CustomMenuDataRef';

export const TestIds = {
  itemWrapper: 'itemWrapper',
  linkWrapper: 'linkWrapper',
  toggle: 'expandablemenu-toggle',
} as const;
